import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import Button from '../ui/Button';

function Pagination({ onPageChange, pageNumber, pageTotal, intl }) {
  let pageInput;

  const onSubmit = (e) => {
    e.preventDefault();
    const newPageNumber = parseInt(pageInput.value, 10) || -1;
    if (newPageNumber > 0 && newPageNumber <= pageTotal) {
      onPageChange(newPageNumber);
    }
    pageInput.value = '';
  };

  return (
    <div
      className={classNames(
        'pagination',
        { 'pagination--inactive': pageTotal <= 1 },
      )}
    >
      {
        pageTotal > 1 ?
        <ul>
          <li className="pagination__prev">
            <Button disabled={pageNumber <= 1} onClick={() => onPageChange(pageNumber - 1)} size="sm">
            <span>
              <i className="pagination__prev-icon" />
            </span>
            </Button>
          </li>
          <li className="pagination__input">
            <form onSubmit={e => onSubmit(e, pageNumber, pageTotal)}>
              <input
                type="text"
                name="page"
                // required to fix issue with the drop down staying on screen after pressing enter
                autoComplete="off"
                placeholder={pageNumber}
                ref={(input) => { pageInput = input; }}
              />
            </form>
          </li>
          <li className="pagination__total-page">
            {intl.formatMessage({ id: 'pagination.pageNumberOfTotal' }, { pageTotal })}
          </li>
          <li className="pagination__next">
            <Button disabled={pageNumber === pageTotal} onClick={() => onPageChange(pageNumber + 1)} size="sm">
            <span>
              <i className="pagination__next-icon" />
            </span>
            </Button>
          </li>
        </ul>
        : null
      }
    </div>
  );
}

Pagination.propTypes = {
  pageNumber: PropTypes.number,
  pageTotal: PropTypes.number,
  onPageChange: PropTypes.func,
};

export default injectIntl(Pagination);



// WEBPACK FOOTER //
// ./src/js/components/Pagination/index.jsx